import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ScrollMoment2 extends HTMLElement {

	constructor() {
		super();
		this.wrapper = this.querySelector(".scroll-moment-wrapper")
		this.init();
	}

	initializeYearDisplay(years, yearDisplay) {
		if (!years.length || !yearDisplay) return;

		// Create year structure based on first year
		const yearDigits = years[0].toString().split('');

		// Create HTML structure for each digit position
		let yearHTML = '';
		yearDigits.forEach((digit, index) => {
			const possibleValues = this.getPossibleValuesForPosition(years, index);
			yearHTML += `<div class="digit-${index}">`;
			possibleValues.forEach(value => {
				yearHTML += `<div class="digit-item">${value}</div>`;
			});
			yearHTML += '</div>';
		});

		yearDisplay.innerHTML = yearHTML;

		// Store references for animation
		this.yearStructure = {
			years,
			digitElements: yearDigits.map((_, index) => yearDisplay.querySelector(`.digit-${index}`)),
			possibleValuesByPosition: yearDigits.map((_, index) => this.getPossibleValuesForPosition(years, index))
		};
	}


	getPossibleValuesForPosition(years, position) {
		// Get digits as they appear in the years, removing consecutive duplicates
		const digitSequence = years.map(year => year.toString()[position]).filter(Boolean);
		
		return digitSequence.filter((digit, i) => i === 0 || digit !== digitSequence[i - 1]);
	}

	animateYearChange(timeline, fromYear, toYear, timeOffset, duration) {
		const fromDigits = fromYear.toString().split('');
		const toDigits = toYear.toString().split('');

		fromDigits.forEach((fromDigit, position) => {
			const toDigit = toDigits[position];

			if (fromDigit !== toDigit && this.yearStructure.digitElements[position]) {
				const digitElement = this.yearStructure.digitElements[position];
				const possibleValues = this.yearStructure.possibleValuesByPosition[position];
				const currentPosition = Math.round(gsap.getProperty(digitElement.children[0], "yPercent") / -100);

				// Find next occurrence of target digit after current position
				let targetIndex = possibleValues.findIndex((value, i) => 
					i > currentPosition && value === toDigit
				);

				// If not found, wrap to beginning
				if (targetIndex === -1) {
					targetIndex = possibleValues.indexOf(toDigit);
				}

				if (targetIndex !== -1) {
					timeline.to(digitElement.children, {
						yPercent: -100 * targetIndex,
						duration,
						ease: "power2.out"
					}, timeOffset);
				}
			}
		});
	}

	init() {
		if (!this.wrapper) return;

		const momentCount = document.querySelectorAll('.story-moment-screen').length;
		const timelineItems = document.querySelectorAll('.story-moment-screen[data-year]');
		const yearDisplay = document.getElementById('year-display');

		// Extract unique years from timeline items and initialize year display
		const allYears = Array.from(timelineItems).map(item => item.dataset.year);
		const years = [...new Set(allYears)];
		this.initializeYearDisplay(years, yearDisplay);

		const scrollTl = gsap.timeline({
			scrollTrigger: {
				trigger: this.wrapper,
				pin: true,
				start: "top top",
				end: `+=${momentCount - 1}00%`,
				scrub: true
			}
		});

		// Dynamic year and story animations
		const offset = 100 / momentCount;
		const backDuration = offset / 2;
		const storyCardStart = 150;
		const storyCardEnd = -150;
		const duration = offset * 2;

		// Animate years and story cards
		years.forEach((year, i) => {
			const x = i + 1;

			// Animate year changes
			if (i > 0) {
				this.animateYearChange(scrollTl, years[i-1], year, offset * i, backDuration);
			}

			// Story count up
			scrollTl
				.fromTo(this.querySelector(`.front-slide${x}`), {
					yPercent: storyCardStart,
				}, {
					yPercent: storyCardEnd,
					duration: duration,
				}, offset * i)
		});

	}
}
